import React from "react";
import './styles.css';
import classNames from 'classnames';

export const statusBodyTemplate = (rowData) => {
    return (
        <div>
            <span className="p-column-title">Status</span>
            <span
                className={classNames(
                    'customer-badge',
                    'Status-' + rowData.Status
                )}
            >
                {rowData.Status}
            </span>
        </div>
    );
};;

export const statusItemTemplate = (option) => {
    return (
        <span className={classNames('customer-badge', 'Status-' + option)}>
            {option}
        </span>
    );
};